import { createVanIconComponent } from "./van"

const Underway = createVanIconComponent("underway")
export default Underway
